import {
  FaBalanceScale,
  FaBook,
  FaCheckDouble,
  FaCreditCard,
  FaFileInvoiceDollar,
  FaReceipt,
  FaUserTie,
} from "react-icons/fa";

/** Reports available to the Finance role only. */
export const FINANCE_PORTAL_LINKS = [
  {
    id: "income-statement",
    title: "Income Statement",
    description: "Income statement for a selected period",
    path: "/finance-statements?tab=income",
    icon: FaCreditCard,
    color: "bg-blue-900",
  },
  {
    id: "balance-sheet",
    title: "Balance Sheet",
    description: "Balance sheet as of a selected date",
    path: "/finance-statements?tab=balance",
    icon: FaBalanceScale,
    color: "bg-indigo-800",
  },
  {
    id: "journal-entry",
    title: "Journal Entry",
    description: "Create and review journal entries",
    path: "/journal-entry",
    icon: FaBook,
    color: "bg-slate-700",
  },
  {
    id: "accounts-payable",
    title: "A/ Payable",
    description: "General account payments (A/P) expenses",
    path: "/general-account-payments",
    icon: FaFileInvoiceDollar,
    color: "bg-emerald-800",
  },
  {
    id: "accounts-receivable",
    title: "A/R Receivable",
    description: "Trade accounts receivable",
    path: "/accounts-receivable",
    icon: FaUserTie,
    color: "bg-teal-800",
  },
  {
    id: "reconcile-general-account",
    title: "General Account Bank Reconciliation",
    description: "Reconcile the general account",
    path: "/reconcile-general-account",
    icon: FaCheckDouble,
    color: "bg-amber-700",
  },
  {
    id: "hst-report",
    title: "HST Report",
    description: "HST collected and input tax credit",
    path: "/hst-report",
    icon: FaReceipt,
    color: "bg-rose-800",
  },
];

export const FINANCE_ALLOWED_PATH_PREFIXES = [
  "/finance-portal",
  "/finance-statements",
  "/journal-entry",
  "/general-account-payments",
  "/accounts-receivable",
  "/reconcile-general-account",
  "/hst-report",
];

export function isFinanceAllowedPath(pathname) {
  const path = String(pathname || "");
  return FINANCE_ALLOWED_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}
